 	// install a JSONP callback for chunk loading
 	function webpackJsonpCallback(data) {
 		var chunkIds = data[0];
 		var moreModules = data[1];
 		var executeModules = data[2];

 		// add "moreModules" to the modules object,
 		// then flag all "chunkIds" as loaded and fire callback
 		var moduleId, chunkId, i = 0, resolves = [];
 		for(;i < chunkIds.length; i++) {
 			chunkId = chunkIds[i];
 			if(Object.prototype.hasOwnProperty.call(installedChunks, chunkId) && installedChunks[chunkId]) {
 				resolves.push(installedChunks[chunkId][0]);
 			}
 			installedChunks[chunkId] = 0;
 		}
 		for(moduleId in moreModules) {
 			if(Object.prototype.hasOwnProperty.call(moreModules, moduleId)) {
 				modules[moduleId] = moreModules[moduleId];
 			}
 		}
 		if(parentJsonpFunction) parentJsonpFunction(data);

 		while(resolves.length) {
 			resolves.shift()();
 		}

 		// add entry modules from loaded chunk to deferred list
 		deferredModules.push.apply(deferredModules, executeModules || []);

 		// run deferred modules when all chunks ready
 		return checkDeferredModules();
 	};
 	function checkDeferredModules() {
 		var result;
 		for(var i = 0; i < deferredModules.length; i++) {
 			var deferredModule = deferredModules[i];
 			var fulfilled = true;
 			for(var j = 1; j < deferredModule.length; j++) {
 				var depId = deferredModule[j];
 				if(installedChunks[depId] !== 0) fulfilled = false;
 			}
 			if(fulfilled) {
 				deferredModules.splice(i--, 1);
 				result = __webpack_require__(__webpack_require__.s = deferredModule[0]);
 			}
 		}

 		return result;
 	}

 	// The module cache
 	var installedModules = {};

 	// object to store loaded CSS chunks
 	var installedCssChunks = {
 		"app": 0
 	}

 	// object to store loaded and loading chunks
 	// undefined = chunk not loaded, null = chunk preloaded/prefetched
 	// Promise = chunk loading, 0 = chunk loaded
 	var installedChunks = {
 		"app": 0
 	};

 	var deferredModules = [];

 	// script path function
 	function jsonpScriptSrc(chunkId) {
 		return __webpack_require__.p + "js/" + ({}[chunkId]||chunkId) + "." + {"chunk-088ff9c4":"0691bd10","chunk-136d193e":"0ad6cf4c","chunk-20d3da9c":"50dd0469","chunk-242063c2":"baba9d57","chunk-26b7f32c":"73a55c38","chunk-2d0c0c33":"88647a94","chunk-2d21a9a9":"3d928093","chunk-2d21f29d":"27222892","chunk-2d22ce37":"22f7837d","chunk-330516b5":"b529a8bc","chunk-3f5d82bd":"c66d6bbd","chunk-3f954034":"00f77d47","chunk-4fb06232":"6ba96939","chunk-5bafd22d":"f7637c5f","chunk-67ffcf6f":"a3fcc508","chunk-78dd2ee2":"f5d311c8","chunk-0710419b":"e05e5833","chunk-09eb3a00":"e2c6bab9","chunk-dba5ab8c":"799a3b6f","chunk-01347524":"021a1121","chunk-1392692b":"a4ae320a","chunk-44a051fc":"a0139143","chunk-62294627":"c458efbe","chunk-6647ba88":"77fdcb76","chunk-6b5ff596":"ecd9cebf","chunk-6da041ae":"dc38337f","chunk-7c5e7ba2":"d3bd7a5a","chunk-adff24e4":"ab21c44d","chunk-1572a9af":"0956bd69","chunk-fe738738":"37854099","chunk-7cc1a4b4":"e3b0cf78","chunk-822a781a":"791f8b16","chunk-aa032d7c":"9afc055d","chunk-abc8e9de":"eba57c54","chunk-518d41cf":"965da119","chunk-d86506f6":"b2366200","chunk-e9918708":"4ea7d3c4","chunk-7f028121":"959123d1","chunk-2d237522":"412e5ee8","chunk-7772b262":"94a0be70"}[chunkId] + ".js"
 	}

 	// The require function
 	function __webpack_require__(moduleId) {

 		// Check if module is in cache
 		if(installedModules[moduleId]) {
 			return installedModules[moduleId].exports;
 		}
 		// Create a new module (and put it into the cache)
 		var module = installedModules[moduleId] = {
 			i: moduleId,
 			l: false,
 			exports: {}
 		};

 		// Execute the module function
 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);

 		// Flag the module as loaded
 		module.l = true;

 		// Return the exports of the module
 		return module.exports;
 	}

 	// This file contains only the entry chunk.
 	// The chunk loading function for additional chunks
 	__webpack_require__.e = function requireEnsure(chunkId) {
 		var promises = [];


 		// mini-css-extract-plugin CSS loading
 		var cssChunks = {"chunk-088ff9c4":1,"chunk-136d193e":1,"chunk-20d3da9c":1,"chunk-242063c2":1,"chunk-330516b5":1,"chunk-3f5d82bd":1,"chunk-3f954034":1,"chunk-4fb06232":1,"chunk-5bafd22d":1,"chunk-67ffcf6f":1,"chunk-78dd2ee2":1,"chunk-0710419b":1,"chunk-09eb3a00":1,"chunk-dba5ab8c":1,"chunk-01347524":1,"chunk-1392692b":1,"chunk-44a051fc":1,"chunk-62294627":1,"chunk-6647ba88":1,"chunk-6b5ff596":1,"chunk-6da041ae":1,"chunk-adff24e4":1,"chunk-1572a9af":1,"chunk-fe738738":1,"chunk-7cc1a4b4":1,"chunk-822a781a":1,"chunk-aa032d7c":1,"chunk-abc8e9de":1,"chunk-518d41cf":1,"chunk-d86506f6":1,"chunk-e9918708":1,"chunk-7f028121":1};
 		if(installedCssChunks[chunkId]) promises.push(installedCssChunks[chunkId]);
 		else if(installedCssChunks[chunkId] !== 0 && cssChunks[chunkId]) {
 			promises.push(installedCssChunks[chunkId] = new Promise(function(resolve, reject) {
 				var href = "css/" + ({}[chunkId]||chunkId) + "." + {"chunk-088ff9c4":"dcee3812","chunk-136d193e":"571e44c4","chunk-20d3da9c":"7c898ed6","chunk-242063c2":"3fd2e09c","chunk-26b7f32c":"31d6cfe0","chunk-2d0c0c33":"31d6cfe0","chunk-2d21a9a9":"31d6cfe0","chunk-2d21f29d":"31d6cfe0","chunk-2d22ce37":"31d6cfe0","chunk-330516b5":"9433c35a","chunk-3f5d82bd":"7733a224","chunk-3f954034":"f996b811","chunk-4fb06232":"c6b4ecff","chunk-5bafd22d":"54af5132","chunk-67ffcf6f":"5a42745a","chunk-78dd2ee2":"cc2d1938","chunk-0710419b":"ac71e945","chunk-09eb3a00":"df8ca7ef","chunk-dba5ab8c":"2d6892db","chunk-01347524":"4c991462","chunk-1392692b":"be13864a","chunk-44a051fc":"74c69025","chunk-62294627":"453e2ed3","chunk-6647ba88":"f806d22a","chunk-6b5ff596":"62ba2dbd","chunk-6da041ae":"7f802405","chunk-7c5e7ba2":"31d6cfe0","chunk-adff24e4":"f894c0fb","chunk-1572a9af":"597271de","chunk-fe738738":"c47bb2ec","chunk-7cc1a4b4":"dc4e5d6d","chunk-822a781a":"47ef4883","chunk-aa032d7c":"6dd0c2e2","chunk-abc8e9de":"52e1c3b6","chunk-518d41cf":"235fa7da","chunk-d86506f6":"dcca3df0","chunk-e9918708":"476d3d6a","chunk-7f028121":"396933a4","chunk-2d237522":"31d6cfe0","chunk-7772b262":"31d6cfe0"}[chunkId] + ".css";
 				var fullhref = __webpack_require__.p + href;
 				var existingLinkTags = document.getElementsByTagName("link");
 				for(var i = 0; i < existingLinkTags.length; i++) {
 					var tag = existingLinkTags[i];
 					var dataHref = tag.getAttribute("data-href") || tag.getAttribute("href");
 					if(tag.rel === "stylesheet" && (dataHref === href || dataHref === fullhref)) return resolve();
 				}
 				var existingStyleTags = document.getElementsByTagName("style");
 				for(var i = 0; i < existingStyleTags.length; i++) {
 					var tag = existingStyleTags[i];
 					var dataHref = tag.getAttribute("data-href");
 					if(dataHref === href || dataHref === fullhref) return resolve();
 				}
 				var linkTag = document.createElement("link");
 				linkTag.rel = "stylesheet";
 				linkTag.type = "text/css";
 				linkTag.onload = resolve;
 				linkTag.onerror = function(event) {
 					var request = event && event.target && event.target.src || fullhref;
 					var err = new Error("Loading CSS chunk " + chunkId + " failed.\n(" + request + ")");
 					err.code = "CSS_CHUNK_LOAD_FAILED";
 					err.request = request;
 					delete installedCssChunks[chunkId]
 					linkTag.parentNode.removeChild(linkTag)
 					reject(err);
 				};
 				linkTag.href = fullhref;

 				var head = document.getElementsByTagName("head")[0];
 				head.appendChild(linkTag);
 			}).then(function() {
 				installedCssChunks[chunkId] = 0;
 			}));
 		}

 		// JSONP chunk loading for javascript

 		var installedChunkData = installedChunks[chunkId];
 		if(installedChunkData !== 0) { // 0 means "already installed".

 			// a Promise means "currently loading".
 			if(installedChunkData) {
 				promises.push(installedChunkData[2]);
 			} else {
 				// setup Promise in chunk cache
 				var promise = new Promise(function(resolve, reject) {
 					installedChunkData = installedChunks[chunkId] = [resolve, reject];
 				});
 				promises.push(installedChunkData[2] = promise);

 				// start chunk loading
 				var script = document.createElement('script');
 				var onScriptComplete;

 				script.charset = 'utf-8';
 				script.timeout = 120;
 				if (__webpack_require__.nc) {
 					script.setAttribute("nonce", __webpack_require__.nc);
 				}
 				script.src = jsonpScriptSrc(chunkId);

 				// create error before stack unwound to get useful stacktrace later
 				var error = new Error();
 				onScriptComplete = function (event) {
 					// avoid mem leaks in IE.
 					script.onerror = script.onload = null;
 					clearTimeout(timeout);
 					var chunk = installedChunks[chunkId];
 					if(chunk !== 0) {
 						if(chunk) {
 							var errorType = event && (event.type === 'load' ? 'missing' : event.type);
 							var realSrc = event && event.target && event.target.src;
 							error.message = 'Loading chunk ' + chunkId + ' failed.\n(' + errorType + ': ' + realSrc + ')';
 							error.name = 'ChunkLoadError';
 							error.type = errorType;
 							error.request = realSrc;
 							chunk[1](error);
 						}
 						installedChunks[chunkId] = undefined;
 					}
 				};
 				var timeout = setTimeout(function(){
 					onScriptComplete({ type: 'timeout', target: script });
 				}, 120000);
 				script.onerror = script.onload = onScriptComplete;
 				document.head.appendChild(script);
 			}
 		}
 		return Promise.all(promises);
 	};

 	// expose the modules object (__webpack_modules__)
 	__webpack_require__.m = modules;

 	// expose the module cache
 	__webpack_require__.c = installedModules;

 	// define getter function for harmony exports
 	__webpack_require__.d = function(exports, name, getter) {
 		if(!__webpack_require__.o(exports, name)) {
 			Object.defineProperty(exports, name, { enumerable: true, get: getter });
 		}
 	};

 	// define __esModule on exports
 	__webpack_require__.r = function(exports) {
 		if(typeof Symbol !== 'undefined' && Symbol.toStringTag) {
 			Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });
 		}
 		Object.defineProperty(exports, '__esModule', { value: true });
 	};

 	// create a fake namespace object
 	// mode & 1: value is a module id, require it
 	// mode & 2: merge all properties of value into the ns
 	// mode & 4: return value when already ns object
 	// mode & 8|1: behave like require
 	__webpack_require__.t = function(value, mode) {
 		if(mode & 1) value = __webpack_require__(value);
 		if(mode & 8) return value;
 		if((mode & 4) && typeof value === 'object' && value && value.__esModule) return value;
 		var ns = Object.create(null);
 		__webpack_require__.r(ns);
 		Object.defineProperty(ns, 'default', { enumerable: true, value: value });
 		if(mode & 2 && typeof value != 'string') for(var key in value) __webpack_require__.d(ns, key, function(key) { return value[key]; }.bind(null, key));
 		return ns;
 	};

 	// getDefaultExport function for compatibility with non-harmony modules
 	__webpack_require__.n = function(module) {
 		var getter = module && module.__esModule ?
 			function getDefault() { return module['default']; } :
 			function getModuleExports() { return module; };
 		__webpack_require__.d(getter, 'a', getter);
 		return getter;
 	};

 	// Object.prototype.hasOwnProperty.call
 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };

 	// __webpack_public_path__
 	__webpack_require__.p = "https://static.www.yuugeai.com/static/";

 	// on error function for async loading
 	__webpack_require__.oe = function(err) { console.error(err); throw err; };

 	var jsonpArray = window["webpackJsonp"] = window["webpackJsonp"] || [];
 	var oldJsonpFunction = jsonpArray.push.bind(jsonpArray);
 	jsonpArray.push = webpackJsonpCallback;
 	jsonpArray = jsonpArray.slice();
 	for(var i = 0; i < jsonpArray.length; i++) webpackJsonpCallback(jsonpArray[i]);
 	var parentJsonpFunction = oldJsonpFunction;


 	// add entry module to deferred list
 	deferredModules.push([0,"chunk-vendors"]);
 	// run deferred modules when ready
 	return checkDeferredModules();
